import { Component, ChangeDetectionStrategy, Renderer2, ElementRef, HostListener, ViewChild, Input, ChangeDetectorRef, ContentChildren, forwardRef } from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AmdDropdownComponent } from '../dropdown/dropdown.component';
import { AmdInputContainerComponent } from '../input-container/input-container.component';
import { AmdOptionComponent } from '../option/option.component';
var AmdSelectComponent = /** @class */ (function () {
    /**
     * @param {?} renderer
     * @param {?} elementRef
     * @param {?} changeDetectorRef
     */
    function AmdSelectComponent(renderer, elementRef, changeDetectorRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.changeDetectorRef = changeDetectorRef;
        this.placeholder = '';
        this.label = '';
        this.isContentActive = false;
        this.value = '';
        this.content = '';
        this.propagateChange = function (value) {
            // do nothing
        };
    }
    /**
     * @return {?}
     */
    AmdSelectComponent.prototype.ngOnInit = function () {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'tabindex', '0');
        this.content = this.placeholder;
    };
    /**
     * @return {?}
     */
    AmdSelectComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.options.forEach(function (option) {
            option.optionClick.subscribe(function () {
                _this.value = option.value;
                _this.content = option.content;
                _this.dropdown.close();
                _this.changeDetectorRef.markForCheck();
                _this.propagateChange(_this.value);
            });
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AmdSelectComponent.prototype.writeValue = function (value) {
        if (!value) {
            return;
        }
        this.value = value;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AmdSelectComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    /**
     * @return {?}
     */
    AmdSelectComponent.prototype.registerOnTouched = function () {
        // todo
    };
    /**
     * @return {?}
     */
    AmdSelectComponent.prototype.onFocus = function () {
        this.inputContainer.focus();
    };
    /**
     * @return {?}
     */
    AmdSelectComponent.prototype.onBlur = function () {
        this.inputContainer.blur();
        this.dropdown.close();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    AmdSelectComponent.prototype.onClick = function (event) {
        if (event.keyCode === ENTER) {
            this.dropdown.toggle();
        }
    };
    /**
     * @return {?}
     */
    AmdSelectComponent.prototype.onTriggerClicked = function () {
        this.isContentActive = true;
    };
    AmdSelectComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-select',
                    template: "<div class=\"amd-select\"> <label *ngIf=\"label\">{{label}}</label> <amd-input-container> <amd-dropdown> <div class=\"amd-select__trigger\" amdDropdownTrigger> <div amdInput>{{content}}</div> </div> <div class=\"amd-select__content amd-menu\" amdDropdownContent> <ng-content></ng-content> </div> </amd-dropdown> </amd-input-container> </div>",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(function () { return AmdSelectComponent; }),
                            multi: true,
                        }
                    ]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdSelectComponent.ctorParameters = function () { return [
        { type: Renderer2, },
        { type: ElementRef, },
        { type: ChangeDetectorRef, },
    ]; };
    AmdSelectComponent.propDecorators = {
        'placeholder': [{ type: Input },],
        'label': [{ type: Input },],
        'dropdown': [{ type: ViewChild, args: [AmdDropdownComponent,] },],
        'inputContainer': [{ type: ViewChild, args: [AmdInputContainerComponent,] },],
        'options': [{ type: ContentChildren, args: [AmdOptionComponent,] },],
        'onFocus': [{ type: HostListener, args: ['focus',] },],
        'onBlur': [{ type: HostListener, args: ['blur',] },],
        'onClick': [{ type: HostListener, args: ['keydown', ['$event'],] },],
    };
    return AmdSelectComponent;
}());
export { AmdSelectComponent };
function AmdSelectComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdSelectComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdSelectComponent.ctorParameters;
    /** @type {?} */
    AmdSelectComponent.propDecorators;
    /** @type {?} */
    AmdSelectComponent.prototype.placeholder;
    /** @type {?} */
    AmdSelectComponent.prototype.label;
    /** @type {?} */
    AmdSelectComponent.prototype.isContentActive;
    /** @type {?} */
    AmdSelectComponent.prototype.value;
    /** @type {?} */
    AmdSelectComponent.prototype.content;
    /** @type {?} */
    AmdSelectComponent.prototype.dropdown;
    /** @type {?} */
    AmdSelectComponent.prototype.inputContainer;
    /** @type {?} */
    AmdSelectComponent.prototype.options;
    /** @type {?} */
    AmdSelectComponent.prototype.propagateChange;
    /** @type {?} */
    AmdSelectComponent.prototype.renderer;
    /** @type {?} */
    AmdSelectComponent.prototype.elementRef;
    /** @type {?} */
    AmdSelectComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=select.component.js.map
//# sourceMappingURL=select.component.js.map
